export default __webpack_public_path__ + "static/media/24H_Yellow_Blue.43d374e4.png";